import React from 'react';
import { parseClasses } from '../../lib/ep.js';

import HTMLContainer from './HTMLContainer.js';

const ButtonCollection = (props) => {
	const in_floating = props?.in_floating ?? false;

	let classes = ['gui_actions'];
	if(in_floating) classes.push('bottom_actions');

	const classname = parseClasses(classes.join(" "), props._class, 'buttons');

	if(props.children == undefined) return null;

	return (
		<HTMLContainer type={props?.type ?? 'div'} id={props.id} className={classname} style={props.style}>
			{props.children}
		</HTMLContainer>
	)
};

export default ButtonCollection;